import { render, staticRenderFns } from "./advantages-partial.vue?vue&type=template&id=7402d60c"
import script from "./advantages-partial.vue?vue&type=script&lang=js"
export * from "./advantages-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports